<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import libraryService from '../../../services/library.service'
import store from '@/state/store'
import Swal from "sweetalert2";
import {required} from "vuelidate/lib/validators";
import vue2Dropzone from "vue2-dropzone";

/**
 * File-manager component
 */
export default {
  page: {
    title: "Image Library",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Layout, vueDropzone: vue2Dropzone, PageHeader},
  mounted() {
    this.fetchLibraries()
    this.dragAndDropCapable = this.determineDragAndDropCapable();
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    fetchLibraries() {
      libraryService.get(null, false, {flutter: true, query: this.query}).then(res => {
        this.libraries = res
        setTimeout(() => {
          this.onLibrariesLoaded()
        }, 200)
      }).catch(error => {
        store.dispatch('toastState/error', error)
      })
    },
    onLibrariesLoaded() {
      if (this.dragAndDropCapable) {
        this.libraries.forEach(item => {
          ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
            if(!this.eventHandlers[item.id]){
              this.eventHandlers[item.id] = (e)=> {
                if (evt == 'dragover' || evt == 'dragenter') {
                  this.fileDropState[item.id] = 1
                } else {
                  this.fileDropState[item.id] = 2
                }
                e.preventDefault();
                e.stopPropagation();
              }
            }
            let eventHandler =  this.eventHandlers[item.id]
            this.$refs['fileUpload_' + item.id][0].removeEventListener(evt,eventHandler);
            this.$refs['fileUpload_' + item.id][0].addEventListener(evt,eventHandler , false);
          }.bind(this));
        })
        this.libraries.forEach(item => {
          if(!this.eventDropHandlers[item.id]){
            this.eventDropHandlers[item.id] = (e)=> {
              for (let i = 0; i < e.dataTransfer.files.length; i++) {
                if (!this.files[item.id]) {
                  this.files[item.id] = []
                }
                this.files[item.id].push(e.dataTransfer.files[i]);
              }
              this.uploadLibraries(item.id, this.files[item.id])
              this.files[item.id] = []
            }
          }
          let eventHandler =  this.eventDropHandlers[item.id]
          this.$refs['fileUpload_' + item.id][0].removeEventListener('drop',eventHandler);
          this.$refs['fileUpload_' + item.id][0].addEventListener('drop',eventHandler);
        })
      }
    },
    async uploadLibraries(id, files) {
      Swal.fire({
        showCancelButton: false,
        showCloseButton: false,
        showConfirmButton: false,
        text: "Please wait...."
      })
      Swal.showLoading()
      let success = true
      try {
        let res = await libraryService.uploadImages(id, files, (progress) => {
          Swal.getContent().textContent = `Files Uploading...  ${progress}/100 Completed`
        })
      } catch (e) {
        store.dispatch('toastState/error', e)
        Swal.close()
        this.fetchLibraries()
        return
      }
      Swal.close()
      store.dispatch('toastState/success', "Upload completed")
      this.fetchLibraries()

    },
    deleteLibrary(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          libraryService.delete(id).then(res => {
            store.dispatch('toastState/success', "Deleted successfully")
            this.fetchLibraries()
          }).catch(err => {
            store.dispatch('toastState/error', err)
          })
        }

      });
    },
    showUpdate(library) {
      this.currentLibrary = library
      this.showCreateModal = true
      this.library = {
        name: library.name,
        watermark : library.watermark,
        is_premium: library.is_premium
      }

    },
    createLibrary() {
      let request = null
      if (!this.currentLibrary) {
        this.$v.$touch()
        if (this.$v.$invalid) {
          return
        }
        request = libraryService.store(this.library)
      } else {
        request = libraryService.update(this.currentLibrary.id, this.library)
      }
      request.then(res => {
        store.dispatch('toastState/success', "Library created successfully")
        this.showCreateModal = false
        this.fetchLibraries()
      }).catch(err => {
        store.dispatch('notification/error', err)
      })
    },
    resizeImages(library){
      libraryService.resize(library.id).then(res=>{
        store.dispatch('toastState/success', "Job started successfully")
      }).catch(err =>{
        store.dispatch('notification/error', err)
      })
    },
    determineDragAndDropCapable() {
      let div = document.createElement('div');
      return (('draggable' in div)
          || ('ondragstart' in div && 'ondrop' in div))
          && 'FormData' in window
          && 'FileReader' in window;
    },
    getDragDropClass(library) {
      return this.fileDropState[library.id] && this.fileDropState[library.id] == 1 ? 'elevated' : ''
    }
  },
  watch: {
    query(value) {
      this.fetchLibraries()
    }
  },
  validations: {
    library: {
      name: {required},
    }
  },
  data() {
    return {
      dragAndDropCapable: false,
      files: [],
      eventHandlers: [],
      eventDropHandlers: [],
      fileDropState: [],
      title: "Image Library",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Libraries",
          active: true,
        },
      ],
      libraries: [],
      query: null,
      currentLibrary: null,
      library: {
        name: "",
        watermark: "",
        is_premium: false
      },
      showCreateModal: false,
      showUploadModal: false,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200,
        maxFilesize: 5,
        previewsContainer: '#previews',
        headers: {"My-Awesome-Header": "header value"}
      }
    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="d-xl-flex">
      <div class="w-100">
        <div class="d-md-flex">
          <div class="w-100">
            <div class="card">
              <div class="card-body">
                <div>
                  <div class="row mb-3">
                    <div class="col-xl-3 col-sm-6">
                      <div class="mt-2">
                        <h5>Libraries</h5>
                      </div>
                    </div>
                    <div class="col-xl-9 col-sm-6">
                      <form
                          class="mt-4 mt-sm-0 float-sm-end d-flex align-items-center">
                        <div class="search-box mb-2 me-2">
                          <div class="position-relative">
                            <input
                                type="text"
                                class="form-control bg-light border-light rounded"
                                v-model="query"
                                placeholder="Search..."/>
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>

                        <b-button @click="showCreateModal = true" variant="light" class="mb-2"><i
                            class="mdi mdi-plus me-1"></i> Create New
                        </b-button>
                      </form>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="row">
                    <div class="col-xl-4 col-sm-6" v-for="library in libraries">
                      <form :ref="'fileUpload_' + library.id">
                        <div class="card shadow-none border" :class="getDragDropClass(library)">
                          <div class="card-body p-3">
                            <div class="">
                              <div class="float-end ms-2">
                                <b-dropdown
                                    toggle-class="font-size-16 text-muted p-0"
                                    menu-class="dropdown-menu-end"
                                    class="mb-2"
                                    variant="white"
                                    right>
                                  <template #button-content>
                                    <i class="mdi mdi-dots-horizontal"></i>
                                  </template>

                                  <b-dropdown-item href="#" @click="showUploadModal = true">Upload Images
                                  </b-dropdown-item>
                                  <b-dropdown-item href="#" @click="showUpdate(library)">Edit</b-dropdown-item>
                                  <b-dropdown-item href="#" @click="resizeImages(library)">Start Resize Job</b-dropdown-item>
                                  <b-dropdown-divider></b-dropdown-divider>
                                  <b-dropdown-item @click="deleteLibrary(library.id)">Remove</b-dropdown-item>
                                </b-dropdown>
                              </div>
                              <div class="avatar-xs me-3 mb-3">
                                <div class="avatar-title bg-transparent rounded">
                                  <i
                                      class="bx bxs-folder font-size-24 text-warning"
                                  ></i>
                                </div>
                              </div>
                              <div class="d-flex">
                                <div class="overflow-hidden me-auto">
                                  <h5 class="font-size-14 text-truncate mb-1">
                                    <a
                                        href="javascript: void(0);"
                                        class="text-body">{{ library.name }}</a>
                                  </h5>
                                  <p class="text-muted text-truncate mb-0">
                                    {{ library.count }} File{{ library.count > 1 ? 's' : '' }}
                                  </p>
                                </div>
                                <div class="align-self-end ms-2" v-if="library.is_premium">
                                  <h2 class="bx bx-crown text-warning"></h2>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                    <!-- end col -->
                  </div>
                  <!-- end row -->
                </div>


              </div>
            </div>
            <!-- end card -->
          </div>
          <!-- end w-100 -->
        </div>
      </div>

      <b-modal v-model="showCreateModal" :title="currentLibrary ? 'Edit Library' : 'Add Library'"
               @ok.prevent="createLibrary">
        <div
            v-if="notification.message"
            :class="'alert ' + notification.type">
          {{ notification.message }}
        </div>
        <div class="row">
          <div class="col-md-12">
            <b-form-group label="Name">
              <b-input placeholder="Enter library name" :class="$v.library.name.$error ? 'is-invalid':''"
                       v-model="library.name"/>
            </b-form-group>

          </div>
          <div class="col-md-12 mt-2">
            <b-form-group label="Watermark">
              <b-input placeholder="Add watermark"
                       v-model="library.watermark"/>
            </b-form-group>

          </div>
          <div class="col-md-12 mt-4">
            <b-form-checkbox
                :value="1"
                v-model="library.is_premium"
                unchecked-value="not_accepted"
                class="mb-3"
                checked
                plain>Is Premium?
            </b-form-checkbox>
          </div>
        </div>

      </b-modal>

      <b-modal v-model="showUploadModal" title="Upload Images">
        <vue-dropzone
            id="dropzone"
            ref="myVueDropzone"
            :use-custom-slot="true"
            :options="dropzoneOptions">
          <div class="dropzone-custom-content">
            <i class="display-4 text-muted bx bxs-cloud-upload"></i>
            <h4>Drop files here or click to upload.</h4>
          </div>
        </vue-dropzone>
        <div id="previews" class="dropzone-previews">
          <div class="dz-preview dz-file-preview">
            <div class="dz-details">
              <div class="dz-filename"><span data-dz-name></span></div>
              <div class="dz-size" data-dz-size></div>
              <img data-dz-thumbnail/>
            </div>
            <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
            <div class="dz-success-mark"><span>✔</span></div>
            <div class="dz-error-mark"><span>✘</span></div>
            <div class="dz-error-message"><span data-dz-errormessage></span></div>
          </div>
        </div>
        <div class="text-center mt-4">
          <button type="button" class="btn btn-primary">Send Files</button>
        </div>
      </b-modal>


    </div>

  </Layout>
</template>

<style scoped lang="scss">
form {

}

.elevated {
  -webkit-box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 3%);
  box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 3%);
}
</style>